import { Token } from '@x-swap-protocol/sdk-core'

export class UserAddedToken extends Token {}
